// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"65984321","732":"7a5a83fb"}[chunkId] + ".chunk.js";
};